import { create } from 'zustand';

const initialState = {
    data: [],
    total: 0,
    totalDay: 0,
    percentTotal: 0
};

export const useAlertN1Store = create((set) => ({

    ...initialState,

    setAlertN1: ({
        data,
        total,
        totalDay,
        percentTotal
    }) => {

        set({
            data,
            total,
            totalDay,
            percentTotal
        });

    },

    clearAlertN1: () => {
        set(initialState);
    }

}));